module.exports = __webpack_public_path__ + "components/layout/images/iphone.png?fcfd9fd5";


//////////////////
// WEBPACK FOOTER
// ./components/layout/images/iphone.png
// module id = 237
// module chunks = 0